import { render } from "./CadastroModelosContratosView.vue?vue&type=template&id=0f7d00c0&scoped=true"
import script from "./CadastroModelosContratosView.vue?vue&type=script&lang=js"
export * from "./CadastroModelosContratosView.vue?vue&type=script&lang=js"

import "./CadastroModelosContratosView.vue?vue&type=style&index=0&id=0f7d00c0&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7d00c0"]])

export default __exports__